import { ActionTypes as c, SelectionType as t } from "./businessModal.types.js";
const p = 50, a = -1, y = (e, s, n = !0) => {
  const r = e.indexOf(s);
  return r !== -1 ? [...e.slice(0, r), ...e.slice(r + 1)] : !n || e.length < p ? [...e, s] : e;
}, h = {
  selectedBusinessIds: [],
  unselectedBusinessIds: [],
  selection: {
    groupIds: [],
    type: t.UNSET,
    searchBusiness: "",
    searchCity: "",
    searchOrg: void 0
  },
  searchBusiness: "",
  searchCity: "",
  searchOrg: void 0,
  searchQueryOrganization: "",
  selectedGroupIds: []
}, o = (e) => ({
  ...h,
  ...e
}), T = (e, s) => {
  switch (s.type) {
    case c.SELECTED_BUSINESS: {
      const {
        isSelected: n,
        businessId: r,
        hasBusinessLimit: l
      } = s.payload, {
        selection: i,
        selectedBusinessIds: u = [],
        unselectedBusinessIds: S = []
      } = e, I = i?.type;
      let d;
      switch (I) {
        case t.UNSET: {
          d = "selectedBusinessIds";
          break;
        }
        case t.ALL_WITH_FILTERS: {
          u.includes(r) ? d = "selectedBusinessIds" : S.includes(r) ? d = "unselectedBusinessIds" : d = n ? "unselectedBusinessIds" : "selectedBusinessIds";
          break;
        }
        default: {
          d = "selectedBusinessIds";
          break;
        }
      }
      const E = y(e[d] ?? [], r, l);
      return {
        ...e,
        [d]: E
      };
    }
    case c.SELECT_ALL:
      return {
        ...e,
        selectedBusinessIds: [],
        unselectedBusinessIds: [],
        selection: {
          groupIds: e.selectedGroupIds?.map(Number) ?? [],
          type: t.ALL_WITH_FILTERS,
          searchBusiness: e.searchBusiness ?? "",
          searchCity: e.searchCity ?? "",
          searchOrg: e.searchOrg
        }
      };
    case c.APPLY:
      return {
        ...e,
        ...o()
      };
    case c.RESET_SELECTION:
      return {
        ...e,
        ...o(s.payload)
      };
    case c.SET_SEARCH_BUSINESS:
      return {
        ...e,
        searchBusiness: s.payload ?? ""
      };
    case c.SET_SEARCH_CITY:
      return {
        ...e,
        searchCity: s.payload?.value.trim() ?? ""
      };
    case c.SET_SEARCH_ORG:
      return {
        ...e,
        searchOrg: s.payload?.value.trim() ? Number(s.payload.value.trim()) : void 0
      };
    case c.SET_SEARCH_QUERY_ORGANIZATION:
      return {
        ...e,
        searchQueryOrganization: s.payload ?? ""
      };
    case c.SELECTED_GROUP: {
      const {
        payload: n
      } = s, {
        selectedGroupIds: r = []
      } = e, l = n === a.toString(), i = r.includes(n);
      return l && !i ? {
        ...e,
        selectedGroupIds: [a.toString()]
      } : i ? {
        ...e,
        selectedGroupIds: r.filter((u) => u !== n)
      } : {
        ...e,
        selectedGroupIds: [...r.filter((u) => u !== a.toString()), n]
      };
    }
    default:
      return e;
  }
};
export {
  p as MAX_BUSINESSES_SELECTED,
  a as NO_GROUP_ID,
  T as businessModalFiltersReducer,
  o as createFreshInitialState
};
